import axios from "axios";
import msal from "../msal";
import { Client } from "./generated";

const scope = `api://${process.env.REACT_APP_CLIENT_ID}/user_impersonation`;

const http = axios.create();
http.interceptors.request.use(async config => {
    try {
        if (msal.getActiveAccount() === null) {
            msal.setActiveAccount(msal.getAllAccounts()[0])
        }

        const authResult = await msal.acquireTokenSilent({ scopes: [scope] });
        config.headers = {
            authorization: `Bearer ${authResult.accessToken}`,
            "content-type": "application/json"
        };
    } catch {
        await msal.acquireTokenRedirect({ scopes: [scope] });
    }

    return config;
}, error => Promise.reject(error));

const api = new Client(window.location.origin, http);

export default api;